import produce from 'immer';
import { v4 as uuidv4 } from 'uuid';

const actions = {
  'MISSION/MAVLINK/APPEND_GRIPPER': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doGripper',
        data: {
          gripper: 1,
          action: 0, // 0: Release, 1: Grab
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_SET_RELAY': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doSetRelay',
        data: {
          relay: 0,
          setting: 1,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_CYCLE_RELAY': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doRepeatRelay',
        data: {
          relay: 0,
          count: 1,
          time: 10,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_SET_SERVO': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doSetServo',
        data: {
          servo: 1,
          pwm: 1500,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_CYCLE_SERVO': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doRepeatServo',
        data: {
          servo: 1,
          pwm: 1000,
          count: 1,
          time: 10,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_DELAY_UNTIL': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'navDelay',
        data: {
          hold: 30,
          hour: 0,
          minute: 0,
          second: 0,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_JUMP_TO_ITEM': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doJump',
        data: {
          item: 1,
          repeat: 10,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_CHANGE_ALTITUDE': (state, action) =>
    produce(state, (draft) => {
      const { altitude } = action.payload;

      const newCommand = {
        id: uuidv4(),
        type: 'navContinueAndChangeAlt',
        data: {
          mode: 1,
          altitude,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_CHANGE_SPEED': (state, action) =>
    produce(state, (draft) => {
      const { speed } = action.payload;

      const newCommand = {
        id: uuidv4(),
        type: 'doChangeSpeed',
        data: {
          type: 0,
          speed,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_VTOL_TRANSITION': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doVtolTransition',
        data: {
          state: 3,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_WAIT_FOR_DISTANCE': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'condDistance',
        data: {
          distance: 10,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_WAIT_FOR_YAW': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'condYaw',
        data: {
          direction: 0,
          offset: 0,
          heading: 0,
          rate: 5,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_TRIGGER_PARACHUTE': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doParachute',
        data: {
          action: 1,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_GUIDED_ENABLE': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'navGuidedEnable',
        data: {
          enable: 1,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_GUIDED_LIMITS': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doGuidedLimits',
        data: {
          timeout: 0,
          minAlt: 25,
          maxAlt: 100,
          horizMoveLimit: 25,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_AUTOTUNE_ENABLE': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doAutotuneEnable',
        data: {
          enable: 1,
        },
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/APPEND_SET_ROI_NONE': (state, action) =>
    produce(state, (draft) => {
      const newCommand = {
        id: uuidv4(),
        type: 'doSetRoiNone',
      };
      draft.json.commands = [...state.json.commands, newCommand];
    }),
  'MISSION/MAVLINK/CHANGE_COMMAND_TYPE': (state, action) =>
    produce(state, (draft) => {
      const { index, type } = action.payload;

      const commands = structuredClone(state.json.commands);
      commands[index].type = type;

      switch (type) {
        case 'navLoiterTime':
          commands[index].data.loiterTime = 30;
          break;

        case 'navLoiterTurns':
          commands[index].data.turns = 1;
          break;

        default:
          break;
      }
      draft.json.commands = commands;
    }),
  'MISSION/MAVLINK/ADD_FENCE': (state, action) =>
    produce(state, (draft) => {
      const { type, data } = action.payload;

      const newFence = {
        id: uuidv4(),
        type,
        data: {
          name: '',
          ...data,
        },
      };
      draft.json.fences = [...state.json.fences, newFence];
    }),
  'MISSION/MAVLINK/EDIT_FENCE': (state, action) =>
    produce(state, (draft) => {
      const { index, values } = action.payload;

      const fences = structuredClone(state.json.fences);
      Object.entries(values).forEach(([name, value]) => {
        fences[index].data[name] = value;
      });
      draft.json.fences = fences;
    }),
  'MISSION/MAVLINK/REMOVE_FENCE': (state, action) =>
    produce(state, (draft) => {
      const { index } = action.payload;

      const fences = [...state.json.fences];
      fences.splice(index, 1);
      draft.json.fences = fences;
    }),
};

export default actions;
